/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id/logs/runs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdLogRuns } from "./constants";
import { toGenerativeAiAgentIdLogRunsResult } from "./toGenerativeAiAgentIdLogRunsResult";
import type {
  GenerativeAiAgentIdLogRunsParams,
  GenerativeAiAgentIdLogRunsResponse,
  GenerativeAiAgentIdLogRunsResult,
} from "./types";
import { isGenerativeAiAgentIdLogRunsResult } from "./validators";

export const getDataTableGenerativeAiAgentIdLogRuns = reactQueryTableFetcherAdapter(
  generativeAiAgentIdLogRuns,
  async (
    signal: AbortSignal,
    {
      appGroupId,
      id,
      search_term,
      limit = 20,
      start = 0,
      outcome,
      calling_location,
      start_date,
      end_date,
    }: GenerativeAiAgentIdLogRunsParams
  ): Promise<GenerativeAiAgentIdLogRunsResult> => {
    const response: GenerativeAiAgentIdLogRunsResponse = await fetch(
      `/generative_ai/agent/${id}/logs/runs`,
      "GET",
      {
        limit,
        start,
        app_group_id: appGroupId,
        search_term,
        outcome,
        calling_location,
        start_date,
        end_date,
      },
      { signal }
    );
    return toGenerativeAiAgentIdLogRunsResult(response);
  },
  isGenerativeAiAgentIdLogRunsResult
);
